import React from 'react';
import _ from 'lodash';

import { useProductInformationWidgetQuery } from 'generated/graphql';
import Big from 'big.js';



export interface IChargeLine {
  id: string;
  name: string;
  subtotalCents: Big;
  taxTotalCents: Big;
}

export interface ILineItem {
  id: string;
  productName: string;
  sku: string;
  quantity: number;
  discountTotalCents: Big;
  itemTotalCents: Big;
  taxTotalCents: Big;
  feeTotalCents: Big;
  refundAmountCents: Big;
}

export interface IData {
  feeLines: IChargeLine[];
  lineItems: ILineItem[];
}

export function useQuery(orderId: string) {
  const queryTuple = useProductInformationWidgetQuery({
    variables: {
      orderId
    }
  });


  return React.useMemo(
    () => {
      const order = queryTuple.data?.order;

      const data: IData = {
        feeLines: _.map([
          ...(order?.feeLines ?? []),
          ...(order?.shippingLines ?? [])
        ], (line): IChargeLine => ({
          id: line.id,
          subtotalCents: new Big(line.subtotalCents),
          taxTotalCents: new Big(line.taxTotalCents),
          name: line.name
        })),
        lineItems: _.map(order?.lineItems, (lineItem): ILineItem => ({
          id: lineItem.id,
          refundAmountCents: new Big(lineItem.refundAmountCents),
          itemTotalCents: new Big(lineItem.itemTotalCents),
          discountTotalCents: new Big(lineItem.discountTotalCents),
          taxTotalCents: new Big(lineItem.taxTotalCents),
          feeTotalCents: new Big(lineItem.feeTotalCents),
          productName: lineItem.product.name,
          quantity: lineItem.quantity,
          sku: lineItem.product.sku
        }))
      };

      return {
        ...queryTuple,
        data
      };
    },
    [queryTuple]
  );
}
